<div *ngIf="!isLoading" class="info-container">
    <div class="info-group">
        <!-- Left group rows -->
        <div class="info-row" style="font-size: 20px;">
            <div class="info-label"><b>Name:</b></div>
            <div class="info-value">{{studentData?.firstName}} {{studentData?.lastName}}&nbsp;</div>
        </div>
        <div class="info-row">
            <div class="info-label"><b>Program:</b></div>
            <div class="info-value">{{program}}&nbsp;</div>
        </div>
        <div class="info-row">
            <div class="info-label"><b>Location/Time:</b></div>
            <div class="info-value">
                {{studentData?.city}}, {{studentData?.state}} 
                ({{ today | date: 'shortTime' }} {{studentData?.geolocation?.timeZoneName}})
            </div>
        </div>
        <div class="info-row" *ngIf="displayPartner">
            <div class="info-label" [style]="partnerTextColorStyle"><b>Partner:</b></div>
            <div class="info-value" [style]="partnerTextColorStyle">{{partnerLeadDisplayName}}</div>
        </div>
    </div>
    <div class="info-group">
        <!-- Right group rows -->
        <div class="info-row" *ngIf="isStitchIn || (showStudentId && callDuration >= studentIdMinTime)">
            <div class="info-label"><b>SyStudentID:</b></div>
            <div class="info-value">
                <span>
                    <a target="_blank" rel="noopener noreferrer" [href]="iDashURL">{{studentData?.id}}</a>
                </span>
            </div>
        </div>
        <div class="info-row" *ngIf="isStitchIn">
            <div class="info-label"><b>Military:</b></div>
            <div class="info-value">{{isMilitary}} &nbsp;</div>
        </div>
        <div class="info-row" *ngIf="!isStitchIn">
            <div class="info-label"><b>Referred By:</b></div>
            <div class="info-value">{{studentData?.referredBy}} &nbsp;</div>
        </div>
        <div class="info-row" *ngIf="displayOtherInfo">
            <div class="info-label" ><b>Other Info:</b></div>
            <div class="info-value" style="color: red;">{{otherInfoMsg}} {{studentFinanceMsg}}</div>
        </div>
    </div>
</div>